import React from 'react'
import { blue, red, yellow, green } from '@mui/material/colors';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import Divider from '@mui/material/Divider';

import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import AppLink from '../../../../components/AppLink';
import { Prescription, Contractor, Patient } from '../../../../models';
import ContractorListWidget from '../contractors/contractor-list.component';
import Centered from '../../../../components/Centered';
import PatientListWidget from '../patients/patients-list.component';
import { ROUTES } from '../../../../history';


const PrescriptionView: React.FC<
    {
        prescription: Prescription;
    }
> = ({
    prescription
}) => {

    const getBody = () => {
        if(prescription.Medicine) {
            return (
                <TableBody>
                {prescription.Medicine.map((drug, index) => (
                  <TableRow
                    key={"drug-" + index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {drug.drug}
                    </TableCell>
                    <TableCell align="right">{drug.dosagePerDay}</TableCell>
                    <TableCell align="right">{drug.amount.toFixed(2)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )
        }
        return <React.Fragment />;
    }
        const getColor = (): string => {
            let color: string;
            switch (prescription.Status) {
                case "Accepted":
                    color = blue[700];
                    break;
                case "Rejected":
                    color = red[700];
                    break;
                case "Completed":
                    color = green[700];
                    break;
                default:
                    color = yellow[800]
                    break;
            }
            return color;

        }

        return (
            <Centered >
                <Paper style={{
                    padding: '1em',
                    borderRadius: '14px',
                    border: 'none',
                    width:'80%',

                    maxWidth: '450px',

                }} elevation={2} >
                    <Typography textAlign={'center'} fontWeight="bold"
                        component="h6" variant="h6">
                        {prescription.title}
                    </Typography>
                    <Typography variant='subtitle1' fontSize={'14px'}  color={'#6B779A'} textAlign={'center'} sx={{
                        mt: 1,

                    }}>

                        {prescription.Amount  > 0 ? `NGN${prescription.Amount}` : "No price available" }
                    </Typography>
      

                    <Typography variant='subtitle1' color={getColor()} textAlign={'center'} sx={{
                        mt: 1,
                        mb: 2,

                    }}

                    >
                        {prescription.Status}
                    </Typography>
        
        <div>
        <TableContainer >
      <Table  aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Drug</TableCell>
            <TableCell align="right">Dosage / Day</TableCell>
            <TableCell align="right">Amount</TableCell>
          </TableRow>
        </TableHead>
            {getBody()}
      </Table>
    </TableContainer>
        </div>


                    <div>
                        <Typography fontWeight={'bold'}>
                            Contractor
                        </Typography>
                       {prescription.Contractor && ( <ContractorListWidget contractor={prescription!.Contractor as Contractor} />)}
                    </div>

                    <div>
                        <Typography fontWeight={'bold'}>
                            Patient
                        </Typography>
                       {prescription.Patient
                        && ( <PatientListWidget patient={prescription!.Patient as Patient} />)}
                    </div>
<Divider />
                    <div style={{
                        margin: '1em 0'
                    }}>
                        <Typography fontWeight={'bold'}>
                           Notes from Pharmacy
                        </Typography>
                        <Typography>
                            {prescription.ContractorExtraInfo}
                        </Typography>
                    </div>


                    <AppLink to={ROUTES.ADMIN_BASE + "/requests/view/" + (prescription.Request as number)}>
                        View Request
                    </AppLink>
                </Paper >
            </Centered>
        )
    }

export default PrescriptionView